import * as React from 'react';
import type { IPopoverManager } from '@inwink/modals';
import type { IConfigurationProviderArgs, IEntityPageConfiguration } from "../entitypagev3/entitypagebase.props";
import type { PopoverAdvancedOptions } from '@inwink/modals/popover';

export interface IEntityPickerModaleProps {
    popovermgr: IPopoverManager;
    entityName: string;
    entityArgs?: IConfigurationProviderArgs;
    multiselect?: boolean;
    disableAutoSelect?: boolean;
    selection?: any[];
    title?: string | ((props?: any) => any);
    excludes?: string[];
    entityConfiguration?: IEntityPageConfiguration;
    disableAddNew?: boolean;
    expands?: string[];
    forceDefaultView?: boolean;
    startFilters?: any;
}

export function pickEntities<T>(props: IEntityPickerModaleProps, showGrid: boolean,
    elt: HTMLElement, className?: string, options?: PopoverAdvancedOptions, wrapper?: (child: any) => any): Promise<T[]> {
    return import(/* webpackChunkName: "iwentitypickerpopover" */ "./entitypickermodale.popover").then((mod) => {
        let component = mod.EntityPickerPopover;
        if (wrapper) {
            component = (p) => wrapper(React.createElement(mod.EntityPickerPopover, p));
        }
        return props.popovermgr.popoverPortal(elt, component, props, "iwentitypickerpopover", options);
    });
}
